import {VbMenuEntry} from "../menu-item.interface";

export const touchMainMenu: VbMenuEntry[] = [
  {
    id: "withdrawal",
    title: 'Artikelentnahme',
    icon: 'shopping-basket',
    link: ['./scannen'],
    disabled: false,
    visible: true
  },
  {
    id: "warehousing",
    title: 'Artikelrückbuchung',
    icon: 'truck',
    link: ['./wareneingang'],
    disabled: false,
    visible: true
  },
  {
    id: "scanlog",
    title: 'Scanlog',
    icon: 'barcode',
    link: ['./scanlog'],
    disabled: false,
    visible: true
  },
  {
    id: "article-search",
    title: 'Artikelsuche',
    icon: 'search',
    link: ['./artikelsuche'],
    disabled: false,
    visible: true
  },
  {
    id: "asset-status",
    title: 'Asset-Status',
    icon: 'question-square',
    link: ['./assetstatus'],
    disabled: false,
    visible: true
  },
  {
    id: "fill-up",
    title: 'Außen-Lager beliefern',
    icon: 'shopping-cart',
    link: ['./lager-auffuellen'],
    disabled: false,
    visible: false
  },
  {
    id: "depot-needs",
    title: 'Lager-Bedarf',
    icon: 'dolly-flatbed-alt',
    link: ['./lager-bedarf'],
    disabled: false,
    visible: false
  },
  {
    id: "stocktaking",
    title: 'Medikamentenkontrolle',
    link: ['./inventur'],
    icon: 'clipboard-check',
    disabled: false,
    visible: true
  },
  {
    id: "vtouch",
    title: 'Zu eStore+ wechseln',
    icon: 'external-link',
    link: ['./vtouch'],
    disabled: false,
    visible: false
  },
  {
    id: "marriage",
    title: 'Verheiraten',
    icon: 'link',
    link: ['./verheiraten'],
    disabled: false,
    visible: true
  },
];



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/navigation/touch-navigation-menu/touch-main.menu.ts